// src/GlobalStyles.jsx
const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');
    @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');

    /* Tema claro (padrão) */
    :root {
      --primary: #2563eb;
      --primary-dark: #1d4ed8;
      --secondary: #10b981;
      --accent: #06b6d4;
      --dark: #0f172a;
      --light: #f8fafc;
      --gray: #64748b;
      --border: #e2e8f0;

      --surface: #ffffff;
      --surface-alt: #f8fafc;
      --navbar-bg: rgba(255,255,255,0.9);
    }

    body {
      font-family: 'Inter', sans-serif;
      background-color: var(--light);
      color: var(--dark);
      overflow-x: hidden;
    }

    /* Tema ESCURO – quando o Provider coloca data-theme="dark" no body */
    body[data-theme='dark'] {
      --primary: #60a5fa;
      --primary-dark: #1d4ed8;
      --secondary: #22c55e;
      --accent: #22d3ee;
      --dark: #e2e8f0;
      --light: #020617;
      --gray: #94a3b8;
      --border: #1e293b;

      --surface: #020617;
      --surface-alt: #0f172a;
      --navbar-bg: rgba(15,23,42,0.9);

      background-color: var(--light);
      color: var(--dark);
    }

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 2rem;
    }

    @media (max-width: 768px) {
      .container {
        padding: 0 1rem;
      }
    }
  `}</style>
);

export default GlobalStyles;
